<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <EventAuthorizationList :user="user" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import EventAuthorizationList from '../components/EventAuthorizationList.vue';

export default {
    components: {
        EventAuthorizationList
    },
    props: {
        user: Object,
    }
};
</script>